import debounce from 'lodash/debounce';
import replaceRoute from './replaceRoute';

export default debounce(
  (route, query) => replaceRoute(route, query),
  500,
);
